export default {
    "tagPicker_createNewTag": "Create new tag"
};